import { Stack } from '@mui/material';
import React from 'react';

import type { ExtensionDocument } from '../../types';
import ExtensionsTable from './components/ExtensionsTable';
import ExtensionSummary from './components/ExtensionSummary';

export interface StepConfigureExtensionsProps {
  extensions: ExtensionDocument[];
  setExtensions: (extensions: ExtensionDocument[]) => void;
  fixedArrearRate: number | null;
  noIvaComision: number | null;
  canChangeArrearRate: boolean;
}

const StepConfigureExtensions: React.FC<StepConfigureExtensionsProps> = ({
  extensions,
  setExtensions,
  fixedArrearRate,
  noIvaComision,
  canChangeArrearRate,
}) => {
  return (
    <Stack direction="column" spacing={2}>
      {/* <PageHeader variant="dialogHeader">
        <PageHeader.Main>
          <PageHeader.TitleSection
            iconType="parameters"
            title="Configurar parámetros"
            subtitle={`${extensions.length} documento${extensions.length > 1 ? 's' : ''} seleccionado${extensions.length > 1 ? 's' : ''}`}
          />
        </PageHeader.Main>
      </PageHeader> */}
      <ExtensionSummary extensions={extensions} noIvaComision={noIvaComision} />
      <ExtensionsTable
        extensions={extensions}
        setExtensions={setExtensions}
        fixedArrearRate={fixedArrearRate}
        noIvaComision={noIvaComision}
        canChangeArrearRate={canChangeArrearRate}
      />
    </Stack>
  );
};

export default StepConfigureExtensions;
